import store from '@/store/index'

export default {}

/**
 * Returns the full state object of the partner tracking module.
 *
 * @returns Object
 */
export const get = () => {
  return store.getters['admin/findPartnersWidgetModule/get']
}

/**
 * Returns the sets of selected partners.
 *
 * @return Object
 */
export const selectedPartnerSets = () => {
  return store.getters['admin/findPartnersWidgetModule/partnerSelectionSets']
}

/**
 * Returns partners that are selected for the specified set.
 *
 * @param set String
 *
 * @return Object
 */
export const selectedPartners = (set) => {
  if (store.getters['admin/findPartnersWidgetModule/partnerSelectionSets'].hasOwnProperty(set)) {
    return store.getters['admin/findPartnersWidgetModule/partnerSelectionSets'][set]
  } else {
    return {}
  }
}

/**
 * Returns the first selected partner in the specified set or null if none is selected.
 *
 * @param set String
 *
 * @return Object|null
 */
export const selectedPartner = (set) => {
  if (store.getters['admin/findPartnersWidgetModule/partnerSelectionSets'].hasOwnProperty(set)) {
    const partners = store.getters['admin/findPartnersWidgetModule/partnerSelectionSets'][set]
    const partnerIds = Object.keys(partners)
    if (partnerIds.length > 0) {
      return partners[partnerIds[0]]
    } else {
      return null
    }
  } else {
    return null
  }
}

/**
 * Returns the first selected partner's id in the specified set
 * or null if none is selected.
 *
 * @param set String
 *
 * @return Object|null
 */
export const selectedPartnerId = (set) => {
  const partner = selectedPartner(set)
  return partner === null ? null : partner.id
}

/**
 * Returns true if the specified partner is selected within the supplied set.
 *
 * @param set String
 * @param id Integer
 *
 * @return Boolean
 */
export const isSelected = (set, id) => {
  return selectedPartners(set).hasOwnProperty(id)
}

/**
 * Returns either a partner object or null depending on whether
 * queries should be made by partner.
 *
 * @return Object|null
 */
export const getPartner = () => {
  return store.getters['admin/findPartnersWidgetModule/getPartner']
}

/**
 * Load the status data of the partners being tracked.
 *
 * @return Promise
 */
export const query = () => {
  return store.dispatch('admin/findPartnersWidgetModule/query')
}

/**
 * Add a map or array of object partners that have been selected within
 * the specified set.
 *
 * @param set String
 * @param partners Array|Map
 */
export const addSelectedPartners = (set, partners) => {
  store.commit('admin/findPartnersWidgetModule/addSelectedPartners', { set, partners })
}

/**
 * Set a single selected partner, all other selected partners
 * in the set will be cleared.
 *
 * @param set String
 * @param partner Object
 */
export const setSelectedPartner = (set, partner) => {
  store.commit('admin/findPartnersWidgetModule/setSelectedPartner', { set, partner })
}

/**
 * Removes an array of partners from the set's list of selected partners.
 * The array must consist of the id's of the partners that are no
 * longer selected.
 *
 * @param set String
 * @param partners Array
 */
export const removeSelectedPartners = (set, partners) => {
  store.commit('admin/findPartnersWidgetModule/removeSelectedPartners', { set, partners })
}

/**
 * Clears all selected partners within a specified set.
 */
export const clearSelectedPartners = (set) => {
  store.commit('admin/findPartnersWidgetModule/clearSelectedPartners', set)
}

/**
 * Clears all selected partners.
 */
export const clearAllSelectedPartners = () => {
  store.commit('admin/findPartnersWidgetModule/clearAllSelectedPartners')
}

/**
 * Returns the selected partner count for the specified set.
 *
 * @param set String
 *
 * @return Integer
 */
export const selectedPartnerCount = (set) => {
  return Object.keys(selectedPartners(set)).length
}

/**
 * Clears all partners from being tracked.
 */
export const purge = () => {
  store.commit('admin/findPartnersWidgetModule/purge')
}



// WEBPACK FOOTER //
// ./src/store/administration/partners/findPartnersWidget.helpers.js